module.exports = __webpack_public_path__ + "img/product_108.071f67f.webp";